(function () {
	const prodSlider = () => {
		$(".product-slider-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return;
			}

			$(this).addClass("slider_started");

			const id = $(this).attr("id");
			const section = $(this).find(".product-slider");
			const autoplay = section.data("autoplay");
			const stopAutoplay = section.data("stop-autoplay");
			const delay = section.data("delay") * 1000;
			const speed = section.data("speed") * 1000;

			const autoplayParm = autoplay
				? {
						autoplay: {
							delay: delay,
							disableOnInteraction: false,
							pauseOnMouseEnter: stopAutoplay,
							waitForTransition: true,
						},
				  }
				: {
						autoplay: false,
				  };

			const prodSliderSwiperParams = {
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				spaceBetween: 4,
				loop: true,
				speed: speed,
				reverseDirection: false,
				effect: "slide",
				...autoplayParm,
			};

			const swiperRightImg = new Swiper(
				`#${id} .product-slider__right-block`,
				{
					...prodSliderSwiperParams,
					parallax: true,
				}
			);

			const swiperLeft = new Swiper(
				`#${id} .swiper-product-slider`,
				{
					navigation: {
						nextEl: `#${id} .swiper-button-next__prod-slider`,
						prevEl: `#${id} .swiper-button-prev__prod-slider`,
					},
					pagination: {
						el: `#${id} .swiper-pagination`,
						clickable: true,
						type: "bullets",
						renderBullet: function (activeIndex, className) {
							return (
								'<span class="' +
								className +
								'">' +
								"<em>" +
								"</em>" +
								"</span>"
							);
						},
					},
					...prodSliderSwiperParams,
					autoplay: false,
				}
			);

			swiperRightImg.controller.control = swiperLeft;
			swiperLeft.controller.control = swiperRightImg;

			if (stopAutoplay && autoplay && swiperRightImg.autoplay) {
				swiperLeft.el.addEventListener("mouseenter", () => {
					swiperRightImg.autoplay.stop();
				});

				swiperLeft.el.addEventListener("mouseleave", () => {
					swiperRightImg.autoplay.start();
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", prodSlider);
	document.addEventListener("shopify:section:load", prodSlider);
})();